import { render } from "./ItemDetail.vue?vue&type=template&id=89863e0a"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__